import { fetcher } from "../services/sagas/fetcher.saga";

import { isSupportedCountry } from "react-phone-number-input";
import JSum from "jsum";
import * as dayjs from "dayjs";

export function deepClone(data) {
  return JSON.parse(JSON.stringify(data));
}

export function deepCompare(data) {
  if (!data) {
    return false;
  }
  return JSum.digest(data, "SHA256", "hex");
}

export function formatNumber(number) {
  return number.toFixed(2).replace(".", ",");
}

export function displayHour(time) {
  return dayjs().add(time, "minute").format("HH:mm");
}

export function displayHourSelected(timeStamps, timezone) {
  let time = dayjs(timeStamps * 1000);
  if (timezone) {
    time = dayjs(time).tz(timezone);
  }
  return time.format("HH:mm");
}

export function isDesktop(window) {
  return window.innerWidth > 760;
}

export function sortWeight(datas) {
  return datas.sort((a, b) => {
    if (a.weightCategory > b.weightCategory) return 1;
    if (a.weightCategory < b.weightCategory) return -1;
    if (a.weight > b.weight) return 1;
    if (a.weight < b.weight) return -1;
  });
}

export const splitStrLang = (language) => {
  return language
    ? language.split("-")[1]
      ? language.split("-")[1].toUpperCase()
      : language.split("-")[0].toUpperCase()
    : "";
};

export const checkCountryCode = (language) => {
  const langNavigator = splitStrLang(language);
  let countryCode = "";
  try {
    if (isSupportedCountry(langNavigator)) {
      countryCode = langNavigator;
    }
  } catch (e) {
    countryCode = "";
  } finally {
    if (!countryCode) {
      countryCode = "FR";
    }
    if (countryCode && countryCode === "CA") {
      countryCode = "ES";
    }
    return countryCode;
  }
};

export const countLines = (products) => {
  return products.reduce((acc, product) => {
    let nbrLines = 0;
    if (product.type === "product") {
      nbrLines = product.extraCategories.length
        ? product.extraCategories.reduce(
            (acc, extra) => (acc = acc + extra.data.length),
            1
          )
        : 1;
    } else {
      nbrLines = product.products_selected.length;
    }
    acc = acc + nbrLines;
    return acc;
  }, 0);
};

export const sendMail = (orderId, idRestaurant, time, text) => {
  fetcher("POST", `order/informed/${orderId}/${idRestaurant}`, {
    selectedTimeTakeAway: time,
    text,
  });
};

export const checkSltTimeOrderBeforeNow = (selectedTimeTakeAway) => {
  if (selectedTimeTakeAway && selectedTimeTakeAway != "false") {
    return dayjs().isAfter(dayjs(selectedTimeTakeAway * 1000))
      ? false
      : selectedTimeTakeAway;
  }
  return false;
};

export const checkSumOrder = (value) => {
  return value >= 0.5;
};

export const checkUser = async (userId) => {
  const result = await fetcher("GET", `user/check-datas/${userId}`);
  return result.data;
};

export const checkOrder = async (
  orderId,
  idRestaurant,
  userId,
  cart,
  sessionPayPlus = "",
  time = ""
) => {
  if (!orderId) {
    return {
      data: {
        success: false,
      },
    };
  }
  const object = {
    order_id: orderId,
    user_id: userId,
    sessionPayPlus,
    idRestaurant,
    time,
    cart,
  };
  return fetcher("POST", "order/check-order", object);
};

export const fetchRestaurant = async (idRestaurant) => {
  return fetcher(
      "GET",
      `/restaurant/info/${idRestaurant}`,
      {},
      ""
  ).then((res) => res.data);
};

export const replaceUrl = () => {
  const { origin, pathname } = window.location;
  window.history.replaceState("", "", `${origin}${pathname}`);
};

export const daysInFrench = {
  sunday: "dimanche ",
  monday: "lundi ",
  tuesday: "mardi ",
  wednesday: "mercredi ",
  thursday: "jeudi ",
  friday: "vendredi ",
  saturday: "samedi ",
};

export const convertToTimestamp = (time) => {
  const [hour, minute] = time.split(':').map(Number);
  return hour + minute / 60;
};

export const isWithinRange = (currentTime, openingTime, closingTime) => {
  const currentDecimal = convertToTimestamp(currentTime);
  const openingDecimal = convertToTimestamp(openingTime);
  const closingDecimal = convertToTimestamp(closingTime);
  return currentDecimal >= openingDecimal && currentDecimal <= closingDecimal;
};

export const findNextOpeningToday = (currentTime, openingHours, day) => {
  const currentDecimal = convertToTimestamp(currentTime);

  for (const plage of openingHours) {
    const openingDecimal = convertToTimestamp(plage.time1);
    if (currentDecimal < openingDecimal) {
      return { day: '', time: plage.time1 };
    }
  }
  return null;
};

export const findNextOpenDay = (weekDay, allOpeningDates, days) => {
  for (let i = 1; i < 7; i++) {
    const nextDayInWeek = (weekDay + i) % 7;
    const nextCurrentDay = allOpeningDates[days[nextDayInWeek]];

    if (nextCurrentDay && nextCurrentDay.length > 0) {
      const nextRange = nextCurrentDay[0];
      const translatedDay = daysInFrench[days[nextDayInWeek]];
      return { day: translatedDay, time: nextRange.time1 };
    }
  }
  return null;
};